import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { InsuranceService } from '../insurance.service';
import { FormsService } from '../../forms/forms.service';
import {InsurancePayeridsComponent} from '../insurance-payerids/insurance-payerids.component';
import {
  InsuranceSelectFeeScheduleComponent
} from "../insurance-select-fee-schedule/insurance-select-fee-schedule.component";

@Component({
    selector: 'app-insurance-profile',
    templateUrl: './insurance-profile.component.html',
    styleUrls: ['./insurance-profile.component.css']
})
export class InsuranceProfileComponent implements OnInit {

    isLoading: boolean = false;
    isError=false;
    dataInsurance: any;
    PatientInsuranceID: string;


    InsuranceID: string;
    OrganizationID: string;
    ProfileOrganization: string;
    Profile: string;
    ProfileOrganizationDesc: string;
    Address1: string;
    Address2: string;
    Address3: string;
    City: string;
    State: string;
    PostCode: string;
    GroupNO: string;
    EmployerNO: string;
    xauditCreatedOn: string;
    PayerID: string;
    PayerIDperNEIC: string;
    PayerOrganization: string;
    FeeScheduleID: string;
    FeeScheduleName: string ;




    // insuranceForms: any[] = [];
    // organizationInsuranceCard: any = {
    //   OrganizationFormID: "",
    //   OrganizationID: "",
    //   enumOrganizationFormTypeId: "",
    //   DFormID: "",
    // };
    // existingFormID: string;

    constructor(
        private dialogRef: MatDialogRef<InsuranceProfileComponent>,
        private insuranceService: InsuranceService,
        private dialog: MatDialog,
        // private formsService: FormsService,
        private snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
    // must check to see if there is already a form...
        const enumInsuranceCardFormType: string = '00000074-1000-0000-0000-000000000003';
        this.PatientInsuranceID = this.data.PatientInsuranceID;
        // this.organizationInsuranceCard.OrganizationID = this.dataInsurance.OrganizationID;
        // this.organizationInsuranceCard.enumOrganizationFormTypeId = enumInsuranceCardFormType;

        this.isLoading = true;

        this.insuranceService.getInsuranceProfile(this.PatientInsuranceID).subscribe(res => {
            console.log('profile:', res);

            if(res.length == 0) {

              this.isError = true;


              return;

            }

            this.InsuranceID               = res[0].InsuranceID;
            this.OrganizationID            = res[0].OrganizationID;
            this.ProfileOrganization       = res[0].ProfileOrganization;
            this.Profile                   = res[0].Profile;
            this.ProfileOrganizationDesc   = res[0].ProfileOrganizationDesc;
            this.Address1                  = res[0].Address1;
            this.Address2                  = res[0].Address2;
            this.Address3                  = res[0].Address3;
            this.City                      = res[0].City;
            this.State                     = res[0].State;
            this.PostCode                  = res[0].PostCode;
            this.GroupNO                   = res[0].GroupNO;
            this.EmployerNO                = res[0].EmployerNO;
            this.xauditCreatedOn           = res[0].xauditCreatedOn;
            this.PayerID                   = res[0].PayerID;
            this.PayerIDperNEIC            = res[0].PayerIDperNEIC;
            this.PayerOrganization         = res[0].PayerOrganization;
            this.FeeScheduleID             = res[0].FeeScheduleID;
            this.FeeScheduleName           = res[0].FeeScheduleName;



        });


        this.isLoading = false;

        // const promises = [
        //     this.getUnusedInsuranceForms(),
        //     this.getCurrentOrganizationInsuranceCard(this.organizationInsuranceCard.OrganizationID),
        // ];
        //
        // Promise.all(promises).then((results: any[]) => {
        //     this.insuranceForms = results[0];
        //     this.insuranceForms = this.insuranceForms.sort((a, b) => {
        //         if (a.DFormName < b.DFormName) {
        //             return -1;
        //         } else if (a.DFormName > b.DFormName) {
        //             return 1;
        //         } else {
        //             return 0;
        //         }
        //     });
        //
        //     if (results[1]) {
        //         this.organizationInsuranceCard.DFormID = results[1].DFormId;
        //         this.insuranceForms.unshift(results[1]);
        //     }
        //
        //     this.isLoading = false;
        //
        // }, err => {
        //     this.showMessage('Error', 'Error fetching forms');
        //     this.isLoading = false;
        // });

    }

    // getCurrentOrganizationInsuranceCard(OrganizationID: string) {
    //     const promise = new Promise((resolve, reject) => {
    //         this.formsService.getOrganizationInsuranceCard(OrganizationID)
    //             .subscribe(resolve, reject);
    //     });
    //     return promise;
    // }
    //
    // getUnusedInsuranceForms() {
    //     const promise = new Promise((resolve, reject) => {
    //         this.formsService.getAllAvailableInsuranceCardForms()
    //             .subscribe(resolve, reject);
    //     });
    //     return promise;
    // }

    // formIsValid() {
    //     return this.organizationInsuranceCard.DFormID;
    // }

    save() {
        this.isLoading = true;


        this.insuranceService.saveInsuranceProfile(this.InsuranceID, this.PayerID, this.FeeScheduleID, this.EmployerNO, this.GroupNO).subscribe(res => {

          this.isLoading = false;
          this.dialogRef.close(false);
        });


        // this.saveOrganizationForm(this.organizationInsuranceCard)
        //     .then((result: any) => {
        //         this.isLoading = false;
        //         this.dialogRef.close(false);
        //     }, err => {
        //         this.isLoading = false;
        //         this.showMessage('Error', 'Error saving form');
        //     });
    }

    // saveOrganizationForm(organizationForm) {
    //     const promise = new Promise((resolve, reject) => {
    //         this.formsService.saveOrganizationForm(organizationForm)
    //             .subscribe(resolve, reject);
    //     });
    //     return promise;
    // }

    close() {
        this.dialogRef.close(false);
    }

    showMessage(type, message) {
        this.snackBar.open(message, type, {
            duration: 3000,
            verticalPosition: 'top'
        });
    }

    onChangePayerID() {

        this.openDialogChoosePayer();

    }

    onChangeFeeSched()  {


      // InsuranceSelectFeeScheduleComponent

      const dialogRef = this.dialog.open(InsuranceSelectFeeScheduleComponent, {
        width: '500px',
        height: '650px',
        panelClass: 'dialog',
        data: {
          FeeScheduleID: this.FeeScheduleID
        }
      }).afterClosed().subscribe(res => {

        this.FeeScheduleID=res.FeeScheduleID;
        this.FeeScheduleName = res.FeeScheduleName;


      });

    }


    openDialogChoosePayer() {
    // open a window to choose a payer
        const dialogRef = this.dialog.open(InsurancePayeridsComponent, {
            width: '530px',
            height: '650px',
            panelClass: 'dialog',
            data: {
                PayerID: this.PayerID
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                // this.payerSelected = result;

                this.PayerID = result.PayerID;
                this.PayerIDperNEIC = result.PayerIDperNEIC;
                this.PayerOrganization = result.Oragnization;


                // if (todo === 'new') {
                //     this.newDataInsurancePayer = this.payerSelected.PayerIDperNEIC + '/' + this.payerSelected.Oragnization;
                //     this.newDataInsurance.PayerID = this.payerSelected.PayerID;
                // }
                // else {
                //     // active
                //     this.activeDataInsurancePayer = this.payerSelected.PayerIDperNEIC + '/' + this.payerSelected.Oragnization;
                //     this.activeDataInsurance.PayerID = this.payerSelected.PayerID;
                // }

            }
        }, err => {
        });
    }



}
